import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  inject,
} from '@angular/core';

import { KeeniconComponent } from '../../partials';
import { BYTES_IN_MEGABYTE, CustomToasterService } from '@core-utils';

@Component({
  selector: 'ui-form-upload-file',
  imports: [KeeniconComponent],
  templateUrl: './form-upload-file.component.html',
  styleUrl: './form-upload-file.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormUploadFileComponent {
  private toastrService = inject(CustomToasterService);

  file = model<File | null>(null);
  description = input<string>('');
  maxFileSizeMb = input<number>(10);
  errorToasterMessage = input<string>('');

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      const file = input.files[0];
      if (this.isValidFileType(file) && this.validateFileSize(file)) {
        this.file.set(file);
      }
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      if (this.isValidFileType(file) && this.validateFileSize(file)) {
        this.file.set(file);
      }
    }
  }

  removeFile() {
    const fileInputId = 'load-file';
    const input = document.getElementById(fileInputId) as HTMLInputElement;
    if (input) {
      input.value = '';
    }
    this.file.set(null);
  }

  private getMaxFileSizeInBytes(): number {
    return this.maxFileSizeMb() * BYTES_IN_MEGABYTE;
  }

  private validateFileSize(file: File): boolean {
    const maxFileSizeBytes = this.getMaxFileSizeInBytes();
    const isFileSizeValid = file.size <= maxFileSizeBytes;

    if (!isFileSizeValid) {
      this.toastrService.error(this.errorToasterMessage());
    }

    return isFileSizeValid;
  }

  private isValidFileType(file: File): boolean {
    const CSV_MIME_TYPE = 'text/csv';
    const CSV_FILE_EXTENSION = '.csv';
    return (
      file.type === CSV_MIME_TYPE || file.name.endsWith(CSV_FILE_EXTENSION)
    );
  }
}
